import request from '@/utils/request';
import axios from 'axios'

export const do_ = (data) => axios.post(setingDefault.correctIP, data,
    {headers: {"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"}}).then(res => {
    return res.data
})

// 一致性检查
export const consistencyCheck = (params) => request({
    url: '/do',
    method: 'get',
    customIP: setingDefault.consistencyCheckIP,
    params,
});

// 正词列表
export const getThesaurus = (params) => request({
    url: '/shuyutong/getDict_rightWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 正词删除
export const deleteThesaurus = (params) => request({
    url: '/shuyutong/deleteDict_rightWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 正词添加
export const addThesaurus = (params) => request({
    url: '/shuyutong/uploadDict_rightWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 正词修改
export const modifyThesaurus = (params) => request({
    url: '/shuyutong/modifyDict_rightWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// ---------- 错词 ------------------

// 列表
export const getWrongThesaurus = (params) => request({
    url: '/shuyutong/getDict_wrongWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 删除
export const deleteWrongThesaurus = (params) => request({
    url: '/shuyutong/deleteDict_wrongWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 添加
export const addWrongThesaurus = (params) => request({
    url: '/shuyutong/uploadDict_wrongWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 修改
export const modifyWrongThesaurus = (params) => request({
    url: '/shuyutong/modifyDict_wrongWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// ---------- 重点监控 ------------------
// 列表
export const getMonitor = (params) => request({
    url: '/shuyutong/getDict_specialWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 删除
export const deleteMonitor = (params) => request({
    url: '/shuyutong/deleteDict_specialWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 添加
export const addMonitor = (params) => request({
    url: '/shuyutong/uploadDict_specialWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 修改
export const modifyMonitor = (params) => request({
    url: '/shuyutong/modifyDict_specialWordsByToken',
    customIP: setingDefault.dicIP,
    method: 'get',
    params,
});

// 辞书查询
export const getDockingDictionaries = (params) => request({
    url: '/shuyutong/dockingDictionaries',
    customIP: setingDefault.dicIP,
    method: 'post',
    params,
});

